import React from 'react';
import GeneralSection from '../general-section';
import StudioItem from './item';

type Props = {
  studios: IStudioItem[],
  title: string,
  icon: string
};

const StudiosSection: React.FC<Props> = ({ studios, title, icon }) => {
  return (
    <GeneralSection title={title} icon={icon} items_count={studios.length} linkToAll={'/studios'}>
      {studios.map((studio, index) => (
        <div key={'studio' + studio.slug + Math.random()}>
          <StudioItem studio={studio} />
        </div>
      ))}
    </GeneralSection>
  );
}

export default StudiosSection;
